import React from "react";
import HeroSection from "../components/Herosection";
import FleetSection from "../components/pluscabsfleet"
import TopRatedRides from "../components/discoverourcabs"
import GogoCabFeatures from "../components/Featurespluscabs";
import YellowSection from "../components/yellosection";
import PlusCabsFAQ from "../components/faqs";
import TestimonialSection from "../components/Testimonials";

const Home = () => {
    return (
        <div>
            <HeroSection />
            <GogoCabFeatures />
           {/* <FleetSection /> */}
           <YellowSection/>
            <TopRatedRides />
                <TestimonialSection/>
            <PlusCabsFAQ/>
            
        </div>
    );
}       
export default Home;